import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { EXPATRIATIONS_ROUTE_PATHS } from './config';

export const EXPATRIATIONS_ROUTES: TApplicationRoute[] = [
  {
    id: 'finance-expatriations',
    path: EXPATRIATIONS_ROUTE_PATHS.expatriations,
    component: lazy(() => import('./pages/expatriations-page')),
    layout: 'default',
    permissions: { roles: [] },
    menu: {
      title: 'Expatriations',
    },
  },
];
